import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.3381 4.0564A1 1 0 0 1 5.6691 4h13A1 1 0 0 1 19 4.0564a2 2 0 0 1 1.2355 1.2548A2 2 0 0 1 20 7.0564a1 1 0 0 1-.091.1163l-4.7399 5.2139V19a1.0001 1.0001 0 0 1-1.6.8l-4-3a1 1 0 0 1-.4-.8v-3.6134l-4.74-5.214a1 1 0 0 1-.091-.1162 2 2 0 0 1 1-3M6.066 6l4.843 5.3273c.1673.1841.2601.4239.2601.6727v3.5l2 1.5v-5c0-.2488.0927-.4886.26-.6727L18.2721 6z",
    clipRule: "evenodd"
}), "Filter", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
